export default (theme) => {
  return `
  .mu-drawer {
    background-color: ${theme.background.paper};
  }
  `;
};



// WEBPACK FOOTER //
// ./src/muse-ui/Drawer/theme.js